import { render, staticRenderFns } from "./SectionLoader.vue?vue&type=template&id=fe7bd0d8&scoped=true&"
import script from "./SectionLoader.vue?vue&type=script&lang=js&"
export * from "./SectionLoader.vue?vue&type=script&lang=js&"
import style0 from "./SectionLoader.vue?vue&type=style&index=0&id=fe7bd0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7bd0d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
